import df from "./dateFormater";
import request from "./request";
import { getSession } from "./sessionHandler";
import t from "../utils/translation.js";

const print = (packageLocation) => {
  const content = `
^XA
^JUS
^XZ
^XA
^FX Top section with logo, name, and address.
^CF0,60
^CF0,30
^FO100,40^FD${t("LocationSpan") || "Location"}^FS
^FO100,70^FD${packageLocation?.locationName}^FS
^FO100,110^GB570,3,3^FS
^FX Centered barcode section.
^BY3,3,80
^FO250,140^BCN,120,Y,N,N^FD${packageLocation?.code}^FS
^XZ
`;
  // Crear un documento HTML temporal
  var ventanaImpresion = window.open("", "", "width=600,height=600");
  ventanaImpresion.document.open();

  // Agregar el content del archivo TXT al documento HTML
  ventanaImpresion.document.write("<pre>" + content + "</pre>");

  ventanaImpresion.document.close();

  // Llamar a la función de impresión
  ventanaImpresion.print();

  // Cerrar la ventana temporal después de la impresión
  ventanaImpresion.close();
};

export default function printLocation(packageLocation) {
  print(packageLocation);
}
